import React from "react";

/*
  A short, cinematic "still-video" moment.
  Rather than shipping an MP4 (which would bloat mobile), we compose a premium
  slow-zoom Ken Burns image with layered atmospheric elements — golden dust,
  soft rays of temple light — that loops smoothly. Muted by default,
  mobile-optimized, and always available (no network video dependency).
*/

export default function CinematicMoment() {
  return (
    <section
      className="relative overflow-hidden bg-black"
      aria-label="Adiyogi meditation moment"
      data-testid="cinematic-moment"
    >
      <div className="relative h-[52vh] min-h-[380px] md:h-[62vh] md:min-h-[520px]">
        {/* Base image — slow cinematic zoom */}
        <div
          className="absolute inset-0 bg-center bg-cover kenburns-3"
          style={{ backgroundImage: "url(/adiyogi-hero.jpg)" }}
          aria-hidden="true"
        />
        {/* Deep cinematic gradient */}
        <div className="absolute inset-0 bg-gradient-to-b from-black/40 via-black/30 to-black/85" />
        {/* Soft golden vignette */}
        <div className="absolute inset-0 pointer-events-none" style={{ boxShadow: "inset 0 0 300px rgba(184,134,11,0.35)" }} />
        {/* Rising temple-light rays */}
        <div className="absolute inset-0 opacity-40 mix-blend-screen animate-rays" aria-hidden="true"
          style={{
            background:
              "radial-gradient(ellipse at 20% 100%, rgba(232,200,120,0.55), transparent 55%), radial-gradient(ellipse at 80% 100%, rgba(232,200,120,0.35), transparent 60%)",
          }}
        />
        {/* Floating golden dust particles */}
        <div className="absolute inset-0 pointer-events-none">
          {Array.from({ length: 22 }).map((_, i) => (
            <span
              key={i}
              className="absolute rounded-full bg-[#E8C878]/70 animate-drift"
              style={{
                width: `${2 + (i % 3)}px`,
                height: `${2 + (i % 3)}px`,
                left: `${(i * 47) % 100}%`,
                top: `${(i * 29) % 100}%`,
                animationDelay: `${(i * 0.4) % 8}s`,
                animationDuration: `${9 + (i % 6)}s`,
                filter: "blur(1px)",
              }}
            />
          ))}
        </div>

        {/* Copy */}
        <div className="relative h-full container-x flex items-center">
          <div className="max-w-2xl text-ivory fade-in-slow">
            <div className="text-[10px] md:text-xs uppercase tracking-[0.45em] text-[#E8C878] mb-4">
              A moment of stillness
            </div>
            <h2 className="font-serif text-4xl md:text-6xl leading-[1.05]">
              Where <span className="gold-text italic">devotion</span>
              <br />
              meets craftsmanship.
            </h2>
            <p className="mt-5 text-sm md:text-lg text-ivory/85 max-w-lg">
              Handcrafted lamps, kalash and pooja essentials — made to be lit, rung and passed down through generations.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}
